export default {
  'label.progress.finished': 'Terminé',
  'label.progress.inprogress': 'En cours',
  'panel.title': 'Chèque',
  'panel.submissionDate': 'Date de soumission',
  'panel.amount': 'Montant',
  'cheque.type.person': 'Personne physique',
  'cheque.type.company': 'Entreprise',
};
